import React from 'react';

import PropTypes from 'prop-types';

import Form from 'components/form-multi/Form';

import { NO_AUTH_LOGIN_REGISTRATION_FORM_NAME } from 'constants/formName';

import { PromoButton } from '../common/PromoButton/PromoButton';
import { PromoRow } from '../common/PromoRow/PromoRow';
import PromoInputPhoneWithDropdown from '../form/PromoInputPhoneWithDropdown/PromoInputPhoneWithDropdown';

export const HeroExtraBlock = (props) => {
    return (
        <Form formName={NO_AUTH_LOGIN_REGISTRATION_FORM_NAME}>
            <PromoRow indent={'adaptive-24-32'}>
                <PromoInputPhoneWithDropdown
                    countries={props.countries}
                    currentCountry={props.currentCountry}
                    labelText={props.labelText}
                    searchPlaceholder={props.searchPlaceholder}
                    searchFullPlaceholder={props.searchFullPlaceholder}
                    searchModalTitle={props.searchModalTitle}
                    searchNoResult={props.searchNoResult}
                />
            </PromoRow>
            <PromoRow textAlign={'center'}>
                <PromoButton
                    type={'button'}
                    onClick={props.onExtraButtonClick}
                    onKeyPress={props.onExtraButtonClick}
                    caption={props.btnTitle}
                    variant={props.btnVariant}
                    id={'acceptInviteBtn'}
                    disabled={props.disabledBtn}
                />
            </PromoRow>
        </Form>
    );
};

HeroExtraBlock.propTypes = {
    labelText: PropTypes.string,
    btnTitle: PropTypes.string,
    btnVariant: PropTypes.string,
    onExtraButtonClick: PropTypes.func,
    disabledBtn: PropTypes.bool,
};
